import Model from 'flarum/common/Model';
export default class ArenaBattle extends Model {
  discussionId() {
    return Model.attribute('discussionId').call(this);
  }
  challengerId() {
    return Model.attribute('challengerId').call(this);
  }
  opponentId() {
    return Model.attribute('opponentId').call(this);
  }
  // Which deck slot each side locked in at battle creation (see
  // CreateBattleController) — the card slider reads through these to show
  // the right deck, not whatever the player currently has selected as
  // their default in the profile editor.
  challengerDeckSlotId() {
    return Model.attribute('challengerDeckSlotId').call(this);
  }
  opponentDeckSlotId() {
    return Model.attribute('opponentDeckSlotId').call(this);
  }
  // Only set when modifier === 'random_cards' — the frozen random card-id
  // pool each side actually plays with this battle, distinct from either
  // deck slot's saved cards. See addCardSlider.tsx for why the slider must
  // read through these instead of the deck slot whenever the modifier is
  // active.
  challengerDeckOverride() {
    return Model.attribute('challengerDeckOverride').call(this);
  }
  opponentDeckOverride() {
    return Model.attribute('opponentDeckOverride').call(this);
  }
  // True once the opponent has explicitly confirmed/picked their own deck
  // slot (rather than just having one auto-locked for them) — see
  // BattleResource::fields() / addCardSlider.tsx's auto-open check.
  opponentDeckConfirmed() {
    return Model.attribute('opponentDeckConfirmed').call(this);
  }
  challengerMana() {
    return Model.attribute('challengerMana').call(this);
  }
  opponentMana() {
    return Model.attribute('opponentMana').call(this);
  }
  actorManaFree() {
    return Model.attribute('actorManaFree').call(this);
  }
  nextPlayerId() {
    return Model.attribute('nextPlayerId').call(this);
  }
  currentTurn() {
    return Model.attribute('currentTurn').call(this);
  }
  status() {
    return Model.attribute('status').call(this);
  }
  expiresAt() {
    return Model.attribute('expiresAt').call(this);
  }
  drawProposedById() {
    return Model.attribute('drawProposedById').call(this);
  }
  drawProposedAt() {
    return Model.attribute('drawProposedAt').call(this);
  }
  // classic|tournament|random_cards|friendly — fixed at creation
  // (ChallengeModal.tsx), see ArenaBattle::MODIFIER_* on the backend. Older
  // battles may still carry infinite_mana/infinite_hp/infinite_turns from
  // before those modifiers were retired from selection.
  modifier() {
    return Model.attribute('modifier').call(this);
  }
}
flarum.reg.add('forumaker-arena', 'common/models/ArenaBattle', ArenaBattle);